import { styled } from "@mui/material/styles";

export const PanelSection = styled("div")`
  padding: ${({ theme }) => theme.kinetic.paddings[20]};
`;
